import { coreTimelineDetailsGetAsyncSlice } from './get';

export const { requestGetCoreTimelineDetails, resetGetCoreTimelineDetails } =
	coreTimelineDetailsGetAsyncSlice.asyncActionCreators;
